<p-toast position="top-center" key="c" (onClose)="onReject()" [baseZIndex]="5000">
  <ng-template let-message pTemplate="message">
    <div class="p-flex p-flex-column" style="flex: 1">
      <div class="p-text-center">
        <!-- <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i> -->
        <p class="m-0">{{ confirmMessage }}</p>
        <p>{{ confirmMessageSummary }}</p>
      </div>
      <div>
        <div class="p-text-center">
          <p-button label="OK" (click)="onReject()" styleClass="p-button-text"></p-button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
<p-toast position="top-center" key="logout"></p-toast>
<div class="reset-pass-container bg-light resetPassword">
  <div class="reset-pass-box">
    <div>
      <div>
        <app-language-selector></app-language-selector>
      </div>
    </div>
    <h1 translate>{{ 'Reset Password' | translate }}</h1>
    <div class="container">
      <div class="card col-md-6 col-xl-5 mt-3 mx-auto">
        <div class="card-body">
          <form [formGroup]="resetPasswordForm" (ngSubmit)="submit()" novalidate>
            <label>{{ 'Current Password' | translate }}<i class="text-danger" aria-hidden="true">*</i></label>
            <label class="d-block">
              <input
                [type]="fieldTempPasswordType ? 'text' : 'password'"
                class="form-control"
                formControlName="tempPassword"
                autocomplete="tempPassword"
                placeholder="{{ 'Current Password' | translate }}"
                maxlength="40"
                required
              />
              <i
                class="fa passwordShow"
                [ngClass]="{
                  'fa-eye-slash': !fieldTempPasswordType,
                  'fa-eye': fieldTempPasswordType
                }"
                (click)="toggleTempPasswordType()"
              ></i>
              <span hidden translate>Current Password</span>
              <small
                class="text-danger"
                *ngIf="
                  !resetPasswordForm.controls['tempPassword'].valid &&
                  (resetPasswordForm.controls['tempPassword'].dirty ||
                    resetPasswordForm.controls['tempPassword'].touched)
                "
              >
                <span *ngIf="resetPasswordForm.controls['tempPassword'].errors?.required">{{
                  'Require CurrentPWD' | translate
                }}</span>
              </small>
            </label>
            <label>{{ 'New Password' | translate }}<i class="text-danger" aria-hidden="true">*</i></label>
            <label class="d-block">
              <input
                [type]="fieldPasswordType ? 'text' : 'password'"
                class="form-control"
                formControlName="password"
                autocomplete="password"
                placeholder="{{ 'New Password' | translate }}"
                maxlength="30"
                pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d.*)(?=.*\W.*)[a-zA-Z0-9\S]{8,15}$"
                required
              />
              <i
                class="fa passwordShow"
                [ngClass]="{
                  'fa-eye-slash': !fieldPasswordType,
                  'fa-eye': fieldPasswordType
                }"
                (click)="togglePasswordType()"
              ></i>
              <span hidden translate>{{ 'New Password' | translate }}</span>
              <small
                class="text-danger"
                *ngIf="
                  !resetPasswordForm.controls['password'].valid &&
                  (resetPasswordForm.controls['password'].dirty || resetPasswordForm.controls['password'].touched)
                "
              >
                <span *ngIf="resetPasswordForm.controls['password'].errors?.required">{{
                  'Require NewPWD' | translate
                }}</span>
                <span *ngIf="resetPasswordForm.controls['password'].errors?.pattern">{{
                  'Valid Password' | translate
                }}</span>
              </small>
            </label>
            <label>{{ 'Confirm Password' | translate }}<i class="text-danger" aria-hidden="true">*</i></label>
            <label class="d-block">
              <input
                [type]="fieldConfirmPasswordType ? 'text' : 'password'"
                class="form-control"
                formControlName="confirmPassword"
                autocomplete="current-password"
                placeholder="{{ 'Confirm Password' | translate }}"
                maxlength="30"
                required
              />
              <i
                class="fa passwordShow"
                [ngClass]="{
                  'fa-eye-slash': !fieldConfirmPasswordType,
                  'fa-eye': fieldConfirmPasswordType
                }"
                (click)="toggleConfirmPasswordType()"
              ></i>
              <span hidden translate
                >{{ 'Confirm Password' | translate }}<i class="text-danger" aria-hidden="true">*</i></span
              >
              <small
                [hidden]="
                  resetPasswordForm.controls.confirmPassword.valid ||
                  resetPasswordForm.controls.confirmPassword.untouched
                "
                class="text-danger"
                translate
              >
                {{ 'Require Confirm Password' | translate }}
              </small>
              <span
                class="text-danger"
                *ngIf="
                  resetPasswordForm.controls['confirmPassword'].valid &&
                  (resetPasswordForm.controls['confirmPassword'].dirty ||
                    resetPasswordForm.controls['confirmPassword'].touched)
                "
              >
                <small
                  *ngIf="
                    resetPasswordForm.controls['password'].value != resetPasswordForm.controls['confirmPassword'].value
                  "
                  >{{ 'New Passwords Match' | translate }}</small
                >
              </span>
            </label>
            <button type="submit" class="btn btn-primary" [disabled]="resetPasswordForm.invalid">
              {{ 'Reset Password' | translate }}
            </button>
            <a href="/home" class="btn btn-primary float-right">{{ 'Cancel' | translate }}</a>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
